import type React from "react"
import { CheckSquare, MessageSquare, UserCheck } from "lucide-react"

type InvoiceQuickCreateActionsProps = {
  compact?: boolean
  onNewComplaint: () => void
  onNewTask: () => void
  onRecoveryTask: () => void
}

const quickActions = [
  {
    key: "complaint" as const,
    label: "New Complaint",
    icon: MessageSquare,
    color: "bg-coral-red text-white hover:bg-coral-red/90",
  },
  {
    key: "task" as const,
    label: "New Task",
    icon: CheckSquare,
    color: "bg-electric-blue text-white hover:bg-btn-hover",
  },
  {
    key: "recovery" as const,
    label: "Recovery Task",
    icon: UserCheck,
    color: "bg-golden-amber text-white hover:bg-golden-amber/90",
  },
]

export const InvoiceQuickCreateActions: React.FC<InvoiceQuickCreateActionsProps> = ({
  compact = false,
  onNewComplaint,
  onNewTask,
  onRecoveryTask,
}) => {
  const handlers = {
    complaint: onNewComplaint,
    task: onNewTask,
    recovery: onRecoveryTask,
  }

  return (
    <>
      {quickActions.map(({ key, label, icon: Icon, color }) => (
        <button
          key={key}
          type="button"
          onClick={handlers[key]}
          className={`inline-flex min-w-0 items-center justify-center gap-1.5 rounded-lg font-medium shadow-sm transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric-blue/30 focus-visible:ring-offset-2 ${color} ${
            compact ? "min-h-12 px-1.5 py-2 text-[11px] leading-tight" : "h-9 px-3 text-sm"
          }`}
        >
          <Icon className="h-4 w-4 shrink-0" />
          <span className={compact ? "text-center" : "whitespace-nowrap"}>{label}</span>
        </button>
      ))}
    </>
  )
}
